/* esm.sh - applesauce-core@5.2.0/helpers */
export * from "/*applesauce-core@5.2.0/esnext/helpers.mjs";
